/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FormBaseData = {
  properties: {
    serviceModalitiesOptions: {
      type: 'array',
      contains: {
        type: 'string',
      },
    },
  },
} as const;
